import React, { useState } from 'react';
import Template from '../../Components/Template/Template';
import MainContainer from '../MainContainer/MainContainer';
import AboutContainer from '../AboutContainer/AboutContainer';
import GamesContainer from '../GamesContainer/GamesContainer';
import GameFiContainer from '../GameFiContainer/GameFiContainer';
import GameFiContainer2 from '../GameFiContainer2/GameFiContainer2';
import WalletContainer from '../WalletContainer/WalletContainer';
import VisionContainer from '../VisionContainer/VisionContainer';
import PartnersContainer from '../PartnersContainer/PartnersContainer';
import ContactsContainer from '../ContactsContainer/ContactsContainer';
import BottomContainer from '../BottomContainer/BottomContainer';
import Modal from '../../Components/Modal/Modal';
import useInput from '../../Components/Hooks/useInput';
import RoadmapContainer from '../RoadmapContainer/RoadmapContainer';

const TemplateContainer = () => {
  const [language, setLanguage] = useState("English")
  const modal = useInput(false);

  return (
    <Template language={language} setLanguage={setLanguage}>
      <div id="Home">
        <MainContainer language={language}/>
      </div>
      <div id="We">
        <AboutContainer language={language}/>
      </div>
      <div id="Games">
        <GamesContainer language={language}/>
      </div>
      <div id="G-Fi">
        <GameFiContainer language={language}/>
        <GameFiContainer2 language={language}/>
      </div>
      <div id="G-Wallet">
        <WalletContainer language={language}/>
      </div>
      <div id="Vision">
        <VisionContainer language={language}/>
      </div>
      <div id="Roadap">
        <RoadmapContainer language={language}/>
      </div>
      <div id="Partners">
        <PartnersContainer language={language}/>
      </div>
      <div id="Contacts">
      <ContactsContainer language={language} modal={modal}/>
      </div>
      <BottomContainer language={language}/>
      <Modal modal={modal} />
    </Template>
  )
}

export default TemplateContainer;